module.exports = __webpack_public_path__ + "static/media/click.5a7464a5.mp3";